module.exports = __webpack_public_path__ + "img/sample-design.f91e10d3.png";